<template>
  <div class="order1">
    <div class="pop" v-if="lodingshow"> <van-loading type="spinner" /></div>
    <top-nav1 ref="TopNav1"></top-nav1>
    <van-nav-bar style="background: #F1F1F1"  title="订单详情" fixed left-arrow @click-left="goBack" >
      <van-icon  @click="onClickRight()" slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div  class="van-content" style="padding-top: 56px;">
      <van-cell-group>
        <div v-if="orderInfo.status==1" style="background:url(/static/images/orderdfh.png)no-repeat center;height: 140px;background-size: 100%;">
          <span style="font-size: 24px;color: white;display: inline-block;position: absolute;line-height: 140px;left: 10%;">待发货</span>
        </div>
        <div v-if="orderInfo.status==2" style="background:url(/static/images/orderyfh.png)no-repeat center;height: 140px;background-size: 100%;">
          <span style="font-size: 24px;color: white;display: inline-block;position: absolute;line-height: 140px;left: 10%;">已发货</span>
        </div>
        <div v-if="orderInfo.status==3" style="background:url(/static/images/orderyfh.png)no-repeat center;height: 140px;background-size: 100%;">
          <span style="font-size: 24px;color: white;display: inline-block;position: absolute;line-height: 140px;left: 10%;">已取消</span>
        </div>
        <!-- <van-cell style="padding-bottom: 0" >收货人信息</van-cell> -->
        <van-cell style="padding-bottom: 0" v-if="dummy!=2&&dummy!=3">
          <template style="overflow: hidden"  slot="title">
            <i style="position: relative;top: 0;font-size: 18px" class="van-icon iconfont icon-unie65c fw " ></i>
            <span style="margin:0 0 0 10px" class="van-cell-text fw ft16">{{userInfo.consignee}}</span>
            <span  class="fw ft16" style="display: inline-block;margin-left: 30px;">{{userInfo.phone}}</span>
          </template>
        </van-cell>
        <!--<van-cell style="padding-bottom: 0" v-if="dummy==2||dummy==3">-->
          <!--<template style="overflow: hidden"  slot="title">-->
            <!--<i style="position: relative;top: -2px;font-size: 18px" class="van-icon iconfont icon-shoujihao fw " ></i>-->
            <!--<span  class="fw ft16">{{userInfo.z_mobile}}</span>-->
          <!--</template>-->
        <!--</van-cell>-->
        <van-cell style="padding:0 0 0 48px" v-if="dummy!=2&&dummy!=3">
          <template style="overflow: hidden"  slot="title">
            <span style="float: left;color: #7A7A7A;padding-right: 15px;" >地址：{{ userInfo.province_str }}{{ userInfo.city_str }}{{ userInfo.county_str }}{{ userInfo.town_str }}{{ userInfo.address }}</span>
          </template>
        </van-cell>
      </van-cell-group>
      <div style="padding: 0 15px">
        <img src="/static/images/eline.png" alt="">
      </div>
      <van-cell-group style="margin-bottom: 0;">
        <van-cell style="padding-bottom: 0" >商品信息
        </van-cell>
        <van-card style="margin: 0;padding: 8px 15px 8px 10px;height: 100px" class="van-cell van-hairline goodsonelist" >
          <router-link slot="thumb" class="goodsimgbox"  :to="{path:'/edetail',query:{id:products.id_product,gid:gid}}">
            <img style="border-radius:6px" :src="products.image" onerror="src='/static/errorimg1.png'">
          </router-link>
          <div @click="godetail(products.id_product)" style="margin-top: 5px;height: 40px" slot="title" class="van-card-title">
            <div class="ellipseal">
              <!--<span class=" radius theme-bg theme-bd  " v-if="dummy == 4">一乡一物</span>-->
              <!--<span class="  radius theme-hot " v-if="dummy == 3">卡券</span>-->
              <!--<span class="  radius theme-bg theme-bd " v-if="dummy == 2">直充</span>-->
              <span class="jd1 " v-if="dummy == 1">优选</span>
              <span class="yx1" v-if="dummy == 6">严选</span>
              <span class="fw ft15">{{ products.name }}</span>
            </div>
          </div>
          <div slot="desc" class="van-card-desc "><span class="float-right" style="color: #A6AAB7">× {{products.number}}</span></div>
        </van-card>
        <div style="padding: 0;height: auto;text-align:right;" class="van-cell">
          <div class="text-right" :class="status==1?'nopadding':'haspadding'" style="width: 100%">
          <!--<div class="text-right"  style="width: 100%">-->
            <router-link v-if="dummy!=2 && dummy!=3 && status==2 "  :to="{path:'/elogistics',query:{orderid:orderInfo.id_order,gid:gid}}">
              <van-button style="background: #fff;margin: 10px 0 10px 15px "  size="small" class=" radius6 ft12 theme-col tcl">查看物流</van-button>
            </router-link>
          </div>
        </div>
      </van-cell-group>
      <div style="padding: 0 15px">
        <img src="/static/images/eline.png" alt="">
      </div>
      <van-cell-group>
        <van-cell style="padding-bottom: 0" >
          <template style="overflow: hidden"  slot="title">
            <span style="float: left" class="van-cell-text fw">订单编号</span><span class="specific" >{{ orderInfo.ordersn }}</span>
          </template>
        </van-cell>
        <van-cell style="padding-bottom: 0" >
          <template style="overflow: hidden"  slot="title">
            <span style="float: left" class="van-cell-text fw">下单时间</span><span class="specific">{{time(orderInfo.add_time)}}</span>
          </template>
        </van-cell>
        <van-cell style="padding-bottom: 0" >
          <template style="overflow: hidden"  slot="title">
            <span style="float: left" class="van-cell-text fw">备注</span ><span class="specific" style="font-size: .24rem;max-width: 80%;" v-html="orderInfo.remark!=''?orderInfo.remark:'无'"> </span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import TopNav1 from "@/components/topnav1";
export default {
  name: "order",
  components: {
    TopNav1
  },

  data() {
    return {
      datas: "",
      products: "",
      userInfo: "",
      orderInfo: "",
      status: "",
      orderID: this.$route.query.id, //订单号
      address: "",
      dummy: "", //是否是虚拟商品
      lodingshow: true,
      gid: this.$route.query.gid
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    godetail: function(id) {
      this.$router.push({ path: "/edetail", query: { id: id, gid: this.gid } });
    },
    onClickRight() {
      this.$refs.TopNav1.topnavPlay();
    },
    time: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    getDatas: function() {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      var _this = this;
      this.$api.get(
        "/active/order/information",
        { id_active: this.gid, token_user: isUser, id_order: this.orderID },
        res => {
          if (res.data.code == "100") {
            this.products = res.data.data.products;
            this.datas = res.data.data;
            this.userInfo = res.data.data.item;
            this.orderInfo = res.data.data.data;
            this.dummy = res.data.data.data.source;
            this.status = res.data.data.data.status;
            this.lodingshow = false;
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({
                    name: "Elogin",
                    query: { gid: this.gid }
                  });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    },
    //去支付
    payOrder: function(id) {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定提交订单，订单提交成功不可取消"
        })
        .then(() => {
          this.pay(res.data.data.id_order);
        })
        .catch(() => {
          this.$api.post(
            "active/order/pay",
            { id_active: this.gid, token_user: isUser, id_order: id },
            res => {
              if (res.data.code == "100") {
                this.$router.push({
                  name: "Eordersucceed",
                  query: { orderId: id, gid: this.gid }
                });
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({
                        name: "Elogin",
                        query: { gid: this.gid }
                      });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            },
            err => {
              this.$toast("服务器繁忙，请稍后再试");
            }
          );
        });
    }
  },
  mounted() {
    this.getDatas();
    $("body").css("background", "#fff");
  },
  destroyed: function() {
    $("body").css("background", "#EFF3F6");
  }
};
</script>

<style lang="less">
.order1 {
  // .van-button__content {
  //   color: red !important;
  // }
  img {
    width: 100%;
  }
  .tcl {
    width: 1.52rem !important;
    height: 0.62rem !important;
    border-radius: 5px;
    border: 1px solid #c4c4c4;
    box-sizing: border-box;
    line-height: 0.62rem;
    .van-button__content {
      font-size: 0.16rem !important;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .specific {
    color: #9e9e9e;
    float: right;
    font-size: 0.28rem;
  }
  .van-card__header {
    width: 100%;
  }
  .haspadding {
    padding: 0px 15px !important;
  }
  .nopadding {
    padding: 0 15px !important;
  }
  .van-hairline--top-bottom::after {
    border-width: 0px !important;
  }
  .van-hairline--bottom.van-nav-bar.van-nav-bar--fixed {
    .van-nav-bar__title {
      text-align: center !important;
      font-weight: bold !important;
    }
  }
  .botbtnbox {
    div {
      padding: 10px 15px;
    }
    text-align: right;
    position: fixed;
    bottom: 0;
    width: 100%;
    margin-bottom: 0;
  }
  .margin_b0 {
    margin-bottom: 0 !important;
  }
  .text-right {
    button {
      margin: 10px 0 10px 10px;
    }
  }
  .van-button--small {
    padding: 0 15px;
    min-width: 80px;
    line-height: 25px;
    border: 1px solid #999;
  }
  .van-card__right {
    display: none;
  }
  .totalPart[class*="van-hairline"]::after {
    border: 1px solid #eee;
  }
  .van-dialog .van-dialog__message {
    padding: 16px 10px;
  }
  .van-cell:not(:last-child)::after {
    left: 0;
  }
  .van-cell:not(:last-child)::after {
    border-bottom: none;
  }
  .goodsonelist .van-card__footer {
    bottom: 8px;
  }
  .title {
    padding: 0 40px;
    background: linear-gradient(top, #ffa286, #ff5355);
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#ffa286),
      to(#ff5355)
    );
    height: 100px;
    line-height: 100px;
    span {
      font-size: 0.4rem;
      color: #fff;
    }
    img {
      width: 80px;
    }
  }
  .van-cell-group {
    background-color: #fff;
    .wuliu .van-icon {
      line-height: 45px;
    }
    .sitebox {
      padding: 0 15px !important;
      .van-icon {
        line-height: 72px;
        font-size: 0.32rem;
        padding-right: 15px;
      }
    }
  }
  .radius {
    padding: 1px 5px !important;
  }
  .pop {
    background-color: #fff !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    .van-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -15px 0 0 -15px;
    }
  }
  .van-nav-bar {
    .van-icon {
      font-size: 0.4rem !important;
    }
  }
}
.theme-bg,
.van-checkbox--checked,
.van-swipe__indicator--active {
  background-color: red !important;
  color: #ffffff !important;
}
.theme-col,
.van-icon-checked {
  color: red !important;
}
.col-hover:hover {
  color: red !important;
}
.col-on {
  color: red !important;
}
.col-focus:focus {
  color: red !important;
}
.col-checked:checked:before {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/order.vue